import React from 'react';
import PropTypes from 'prop-types';

import { Icon, ItemArrow } from 'components/common/Elements/Elements';

import classes from './SatisfactionItem.module.scss';

const SatisfactionItem = ({ item }) => {
  let color = null;

  switch (item.icon) {
    case 'champion':
      color = 'green';
      break;
    case 'smile':
      color = 'lgreen';
      break;
    case 'needAttention':
      color = 'yellow';
      break;
    case 'sad':
      color = 'red';
      break;
    default:
      color = 'base';
  }

  return (
    <div className={classes.platform}>
      <div className={classes.left}>
        <div className={classes.icon}>
          <Icon icon={item.icon} className={classes[color]} size="16px" />
        </div>
        {item.content}
      </div>
      <ItemArrow route={item.url} disabled={item.disabled} />
    </div>
  );
};

SatisfactionItem.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    content: PropTypes.node,
    url: PropTypes.string,
    disabled: PropTypes.bool
  })
};

export default SatisfactionItem;
